export default __webpack_public_path__ + "static/recipes-22a88066fcd89aa300e0af6b6404aa1a.jpg";